import { render, staticRenderFns } from "./ContaConfiguracaoLandingpage.vue?vue&type=template&id=251063bb&scoped=true&"
import script from "./ContaConfiguracaoLandingpage.vue?vue&type=script&lang=js&"
export * from "./ContaConfiguracaoLandingpage.vue?vue&type=script&lang=js&"
import style0 from "./ContaConfiguracaoLandingpage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ContaConfiguracaoLandingpage.vue?vue&type=style&index=1&id=251063bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251063bb",
  null
  
)

export default component.exports